module.exports = __webpack_public_path__ + "static/img/qq-select.cf237405.svg";